'use client';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  children: React.ReactNode;
  selector?: Element | DocumentFragment | null;
}

export function Portal({ children, selector }: PortalProps) {
  const [mounted, setMounted] = useState(false);
  const [element, setElement] = useState<Element | DocumentFragment | null>(() => getRoot(selector));

  useEffect(() => {
    setElement(getRoot(selector));
    setMounted(true);
  }, [selector]);

  return mounted && element ? createPortal(children, element) : null;
}

function getRoot(root?: Element | DocumentFragment | null) {
  const fallback = document.body;
  if (typeof root === 'string') {
    return document.querySelector('#' + root + '-root') ?? fallback;
  }
  if (root instanceof Element || root instanceof DocumentFragment) {
    return root;
  }
  return fallback;
}
